import React from 'react';
import { clearFormat, formatDate, formatValueIfNullOrUndefined } from 'utilities/util';
import { PropertiesRibbonWrapper } from 'components/properties-ribbon';
import { jobClose } from 'constants/customs';
import Tooltip from 'components/tooltip';
import { sales_order_icon } from 'components/exception-management/constants';

interface ITopBarOwnProps {
    number: string;
    shipmentType: string;
    placeOfDesconsolidation: string;
    placeOfDeliveryCode: string;
    portOfDischargeCode: string;
    quantity: string;
    volume: string;
    weight: string;
    package: string;
    soNumber: string;
    tentativeCloseDate: string;
    isJobClosed: string;
    reopenDate: string;
    onUpdate: (id:any)=> void
    onCancel: (id:any)=> void
    onCreate: (id:any)=> void
    onResend: (id:any)=> void
    onAthenaRefresh: (id: any) => void
    onSendCreateSalesOrder: (id: any) => void
    showCreate: boolean
    showUpdate: boolean
    showCancel: boolean
    showResend: boolean
    showAthenaRefresh: boolean
    isActionHidden: boolean
    isResendMessageFeatureEnabled: boolean
    isSAPJobCloseNotification: boolean;
    incoTerm: string;
    showCreateSalesOrder: boolean;
}

export const DetailsTopBar: React.FunctionComponent<ITopBarOwnProps> = (props) => {
    const getActions = ():any[] => {
        const resp:any[] = []
        if(props.showCreate){
            resp.push({label: 'Create Sales Order (Resend)', action: () => props.onCreate({id: props.number})})
        }
        if(props.showUpdate){
            resp.push({label: 'Update Sales Order', action: () => props.onUpdate({id: props.number})})
        }
        if(props.showCancel){
            resp.push({label: 'Cancel Sales Order', action: () => props.onCancel({id: props.number})})
        }
        if(props.showResend && props.isResendMessageFeatureEnabled){
            resp.push({label: 'Resend Latest Message', action: () => props.onResend({id: props.number})})
        }
        if (props.showAthenaRefresh) {
            resp.push({ label: 'Refresh Athena Rate', action: () => props.onAthenaRefresh({ id: props.number }) })
        }
        if (props.showCreateSalesOrder) {
            resp.push({ label: 'Send Create Sales Order', action: () => props.onSendCreateSalesOrder({ id: props.number }) })
        }
        return resp
    }
    const propertiesRibbonData = {  
        labels: [
            { label: 'Shipment Number', value: formatValueIfNullOrUndefined(props.number), key:`ets-type`  },
            { label: 'Shipment Type', value: formatValueIfNullOrUndefined(props.shipmentType), key:`ets-type`  },
            { label: 'Place Of Delivery', value: formatValueIfNullOrUndefined(props.placeOfDeliveryCode), key:`ets-placeOfDeliveryCode` },
            { label: 'Port Of Discharge', value: formatValueIfNullOrUndefined(props.portOfDischargeCode), key:`ets-portOfDischargeCode` },
            { label: 'Place of Desconsolidation', value: `${formatValueIfNullOrUndefined(props.placeOfDesconsolidation)}`, key:`ets-originService` },
            { label: 'Quantity', value: formatValueIfNullOrUndefined(props.quantity), key:`ets-quantity` },
            { label: 'Volume', value: formatValueIfNullOrUndefined(clearFormat(props.volume, 3)), key:`ets-volume` },
            { label: 'Weight', value: formatValueIfNullOrUndefined(clearFormat(props.weight, 3)), key:`ets-weight` },
            { label: 'Package', value: formatValueIfNullOrUndefined(props.package), key:`ets-package` },
            { label: 'SO Number', value: formatValueIfNullOrUndefined(props.soNumber), key:`ets-soNumber` },
        ],
        actions: getActions(),
        isActionHidden: props.isActionHidden
    }
   
    
    const getData = (): any => {
        const propertiesRibbonData1 = {  
            labels: [
                { label: 'Estimated Job Close Date', value: formatDate(props.tentativeCloseDate, 'YYYY-MM-DD'), key:`tentative-CloseDate` },
                { label: 'Job Closed Status', value: props.isJobClosed === 'REOPENED' || props.isJobClosed === 'CLOSED' ? getHmtlforJobClose(props.isJobClosed) : formatValueIfNullOrUndefined(props.isJobClosed), key:`is-JobClosed` },
                { label: 'Incoterm', value: formatValueIfNullOrUndefined(props.incoTerm), key: `fcr-incoTerm` },
                { label: 'Job Reopened Date', value: formatDate(props.reopenDate, 'YYYY-MM-DD'), key:`tentative-CloseDate` },
            ],
            actions: [],
            isActionHidden: true
        }
        if(props.isJobClosed !== 'REOPENED') {
            propertiesRibbonData1.labels.pop()
        }
        return propertiesRibbonData1
    }

    const getHmtlforJobClose = (status: string) => 
        <><span dangerouslySetInnerHTML={{ __html: `${status}` }} />
        <Tooltip content={status === 'CLOSED' ? jobClose.CLOSE : jobClose.REOPEN} id={'exportJob'}><span className="padding-left-small" dangerouslySetInnerHTML={{ __html:`${sales_order_icon.jobClose}` }}/></Tooltip></>
        
    return (
        <React.Fragment>
            <PropertiesRibbonWrapper content={propertiesRibbonData} key={`-bookingDetailsTopBar-${Math.random()}`}/>
            {props.isSAPJobCloseNotification &&
            <div>
                <PropertiesRibbonWrapper content={getData()} key={`-bookingDetailsTopBar-${Math.random()}`}/>
            </div>
            }
        </React.Fragment>
    )
};